import { render, staticRenderFns } from "./GestionTep.vue?vue&type=template&id=24ae8c25"
import script from "./GestionTep.vue?vue&type=script&lang=js"
export * from "./GestionTep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports